import React, { Component } from "react";
import Headers from "../Layouts/Headers";

import { GynecologySidebar } from "../Layouts/GynecologySidebar";
import axios from "axios";
import $ from "jquery";
// import { GynecologySidebar } from '../Layouts/GynecologySidebar'

export class GMenstrualHistory extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      chiefComplaint: "chiefComplaint",
      AgeOfMenarche: "",
      LMP: "",
      EDD: "",
      GestationalAge: "",
      CycleRegular: "",
      Duration: "",
      Quantity: "",
      AssociationPain: "",

      // 				visitid = request.headers["visitid"],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {}

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    console.log(this.state);
    axios.post(this.api_url+""+localStorage.getItem('currentModule')+"/menstrualhistory/main",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);

        if (response.data["status"]) {
          $(".alert-success").show();

          setTimeout(function () {
            window.location.href = "/gynecology/previous/obstetricsHistory";
          }, 500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const {
      chiefComplaint,
      AgeOfMenarche,
      LMP,
      EDD,
      GestationalAge,
      CycleRegular,
      Duration,
      Quantity,
      AssociationPain,
    } = this.state;
    return (
      <div>
        <Headers />
        <GynecologySidebar></GynecologySidebar>
        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Menstrual History
                  </p>
                </div>

                <div className="col-md-6 p-2">
                  {/* <div className="py-1">
                         <h6 className="text-capitalize" style={ fontFamilyNunito }>Chief Complaint</h6><textarea className="form-control" onChange={this.handleChange} value={chiefComplaint} name="chiefComplaint" required></textarea>
                     </div> */}

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Age Of Menarche
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={AgeOfMenarche}
                      name="AgeOfMenarche"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      LMP
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={LMP}
                      name="LMP"
                      type="date"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      EDD
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={EDD}
                      name="EDD"
                      type="date"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Gestational Age
                    </h6>
                    <input
                      onChange={this.handleChange}
                      value={GestationalAge}
                      name="GestationalAge"
                      className="form-control"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Cycle Regular
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={CycleRegular}
                      name="CycleRegular"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Duration
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Duration}
                      name="Duration"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Quantity
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Quantity}
                      name="Quantity"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Association Pain
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={AssociationPain}
                      name="AssociationPain"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert  alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Menstrual History Saved Successfully.
              </div>

              <div className="row pt-4">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default GMenstrualHistory;
